import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const QRCodeManager = ({ businessData }) => {
  const [showInstructions, setShowInstructions] = useState(false);

  const handleDownloadQR = () => {
    const link = document.createElement('a');
    link.href = businessData?.qrCode;
    link.download = `BIZZNET_QR_${businessData?.name?.replace(/\s+/g, '_')}.png`;
    link?.click();
  };

  const handlePrintQR = () => {
    const printWindow = window.open('', '_blank');
    printWindow?.document?.write(`
      <html>
        <head>
          <title>Código QR - ${businessData?.name}</title>
          <style>
            body { 
              display: flex; 
              flex-direction: column; 
              align-items: center; 
              justify-content: center; 
              min-height: 100vh; 
              margin: 0; 
              font-family: Arial, sans-serif; 
            }
            img { 
              max-width: 400px; 
              margin: 20px; 
            }
            h1 { 
              font-size: 24px; 
              margin: 10px; 
            }
            p { 
              font-size: 16px; 
              color: #666; 
            }
          </style>
        </head>
        <body>
          <h1>${businessData?.name}</h1>
          <img src="${businessData?.qrCode}" alt="Código QR de ${businessData?.name}" />
          <p>Escanea para obtener descuentos exclusivos</p>
        </body>
      </html>
    `);
    printWindow?.document?.close();
    printWindow?.print();
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-card p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground">Tu Código QR</h3>
          <p className="text-sm text-muted-foreground mt-1">
            Comparte este código con tus clientes
          </p>
        </div>
        <button
          onClick={() => setShowInstructions(!showInstructions)}
          className="flex items-center gap-2 text-sm text-primary hover:underline"
        >
          <Icon name="HelpCircle" size={16} />
          Instrucciones
        </button>
      </div>
      <div className="flex flex-col items-center gap-6">
        <div className="w-64 h-64 rounded-lg overflow-hidden border-4 border-primary shadow-lg">
          <Image
            src={businessData?.qrCode}
            alt={`Código QR de ${businessData?.name} para escanear y obtener descuentos exclusivos en BIZZNET`}
            className="w-full h-full object-contain bg-white"
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 w-full max-w-md">
          <Button
            variant="default"
            iconName="Download"
            onClick={handleDownloadQR}
            fullWidth
          >
            Descargar QR
          </Button>
          <Button
            variant="outline"
            iconName="Printer"
            onClick={handlePrintQR}
            fullWidth
          >
            Imprimir QR
          </Button>
        </div>

        <div className="w-full max-w-md bg-muted rounded-lg p-4">
          <div className="flex items-start gap-3">
            <Icon name="BarChart3" size={20} color="var(--color-primary)" />
            <div className="flex-1">
              <p className="text-sm font-medium text-foreground">Estadísticas de Escaneo</p>
              <div className="grid grid-cols-2 gap-4 mt-3">
                <div>
                  <p className="text-2xl font-bold text-foreground">{businessData?.totalScans}</p>
                  <p className="text-xs text-muted-foreground">Total Escaneos</p>
                </div>
                <div>
                  <p className="text-2xl font-bold text-foreground">{businessData?.uniqueCustomers}</p>
                  <p className="text-xs text-muted-foreground">Clientes Únicos</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {showInstructions && (
          <div className="w-full max-w-md bg-primary/5 rounded-lg p-4 border border-primary/20">
            <h4 className="text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
              <Icon name="Lightbulb" size={16} color="var(--color-primary)" />
              Cómo usar tu código QR
            </h4>
            <ul className="space-y-2 text-sm text-foreground">
              <li className="flex items-start gap-2">
                <Icon name="Check" size={16} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                <span>Descarga e imprime el código QR en alta calidad</span>
              </li>
              <li className="flex items-start gap-2">
                <Icon name="Check" size={16} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                <span>Colócalo en un lugar visible de tu negocio (entrada, caja, mesas)</span>
              </li>
              <li className="flex items-start gap-2">
                <Icon name="Check" size={16} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                <span>Los clientes lo escanean con la app BIZZNET para obtener descuentos</span>
              </li>
              <li className="flex items-start gap-2">
                <Icon name="Check" size={16} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                <span>Recibirás notificaciones de cada escaneo con datos del cliente</span>
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default QRCodeManager;